var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-main',[_c(_setup.LPHeader),_c('router-view'),_c(_setup.LPFooter)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }